<template>
  <PlatformLayout :useOverlay="overlay">
    <v-container fluid>
      <xlsx-read :file="file">
        <xlsx-json @parsed="imported"></xlsx-json>
      </xlsx-read>
      <h2 class="text-center">Importación de servicios</h2>
      <v-row>
        <v-col cols="4" offset="4">
          <v-file-input
            :rules="rules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            placeholder="Selecciona tu archivo excel"
            label="Archivo a importar"
            show-size
            @change="onChange"
          ></v-file-input>
        </v-col>
        <v-col cols="8" class="mx-auto" v-if="serviciosImport.length > 0">
          <h3>Servicios a importar</h3>
          <br />
          <v-alert color="blue" type="info">
            El aceptar esta importación implicará borrar definitivamente todos
            los registros actuales de servicios para dar de alta los
            pertenecientes a esta lista.
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="serviciosImport.length > 0 && errores.length == 0">
        <v-col cols="8" class="mx-auto">
          <v-btn @click="uploadNewServices">CARGAR NUEVO CATÁLOGO</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="errores.length > 0">
        <v-col cols="8" class="mx-auto">
          <h3>Errores de formato</h3>
          <br />
          <v-alert color="red" type="error">
            El formato proporcionado presenta los siguientes errores.
            <br />
            <v-list-item class="text-center">
              <v-list-item-content
                v-for="(error, index) of errores"
                :key="index"
              >
                {{ error }}
              </v-list-item-content>
            </v-list-item>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="serviciosImport.length > 0">
        <v-col cols="8" class="mx-auto">
          <v-data-table
            :headers="headers"
            :items="serviciosImport"
            :items-per-page="-1"
            class="elevation-3"
            :footer-props="{
              itemsPerPageText: 'El. por página',
              itemsPerPageAllText: 'Todo',
              itemsPerPageOptions: ippoptions,
            }"
            no-data-text="No hay datos para mostrar"
          >
            <template v-slot:[`item.codigo`]="{ item }">
              <div>{{ item.codigo || "---" }}</div>
            </template>
            <template v-slot:[`item.precio_lista`]="{ item }">
              <div>{{ item.precio_lista || 0 | currency }}</div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import { XlsxRead, XlsxJson } from "vue-xlsx";
import { httpPost } from "@/services/apiService";

export default {
  name: "ImportacionServicios",
  components: {
    PlatformLayout,
    XlsxRead,
    XlsxJson,
  },
  data() {
    return {
      file: null,
      serviciosImport: [],
      rules: [
        (value) =>
          !value ||
          value.size < 20000000 ||
          "El archivo no puede ser mayor que 20 MB.",
      ],
      headers: [
        {
          text: "Código",
          align: "center",
          sortable: false,
          value: "codigo",
        },
        {
          text: "Descripción",
          align: "center",
          sortable: false,
          value: "descripcion",
        },
        {
          text: "Unidad",
          align: "center",
          sortable: false,
          value: "unidad",
        },
        {
          text: "Precio de lista",
          align: "center",
          sortable: false,
          value: "precio_lista",
        },
      ],
      ippoptions: [-1],
      errores: [],
      overlay: false,
    };
  },
  methods: {
    onChange(event) {
      this.file = event;
    },
    async imported(event) {
      (event);
      this.overlay = true;
      if (!this.file) {
        this.overlay = false;
        this.$toasted.show(
          "No se ha podido detectar formato adecuado en el archivo, revisarlo",
          {
            type: "error",
          }
        );
        return;
      }

      for (let item of event) {
        this.serviciosImport.push({
          codigo: item["CODIGO"],
          descripcion: item["DESCRIPCION"]?.toUpperCase(),
          unidad: item["UNIDAD"]?.toUpperCase() || "SER",
          precio_lista: item["PRECIO DE LISTA"] || 0,
        });
      }

      (this.serviciosImport);

      this.overlay = false;
    },
    async uploadNewServices() {
      this.overlay = true;

      const { data } = await httpPost("/servicios/bulk-upload", {
        data: { services: this.serviciosImport },
      }).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error, no se puede cargar el formato, hable a soporte",
          {
            type: "error",
          }
        );
        this.overlay = false;
      });

      this.$toasted.show(data?.message, {
        type: "success",
      });

      this.serviciosImport = [];
      this.overlay = false;
      this.$router.push({ path: "/platform/servicios" });
    },
  },
};
</script>
